<div>
    <div [ngClass]="{ 'row': true, 'row-reversed': isIncoming }">
        <div class="column">
            <mm-from-account-details-condensed [subtitle]="isIncoming ? receivingSubtitle : sourceSubtitle"></mm-from-account-details-condensed>
        </div>
        <div class="column">
            <mm-receiving-account-details-condensed [subtitle]="isIncoming ? sourceSubtitle : receivingSubtitle"></mm-receiving-account-details-condensed>
        </div>
    </div>
    <mm-transaction-details-ach-condensed></mm-transaction-details-ach-condensed>
    <mm-twe-details-section 
    *ngIf="isIra"
    [transactionType]="ach"
    data-testid="twe-details-section_ach">
    </mm-twe-details-section>
    <mm-ptrs-details-condensed *ngIf="isPtrs && !isIncoming" data-testid="ptrs-details-section_ach"></mm-ptrs-details-condensed>
</div>